"use client"
import React, { useState, createContext } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const pathProps = {
    initial: (custom: { delay: number, duration: number }) => ({
        pathLength: 0,
        opacity: 0,
    }),

    animate: (custom: { delay: number, duration: number }) => ({
        pathLength: 1,
        opacity: 1,
        transition: {
            opacity: { duration: 0.1, delay: custom.delay },
            pathLength: { type: "tween", duration: custom.duration, bounce: 0, delay: custom.delay },
        },
    }),
    strokeOpacity: 1,
    fill: "none",
    strokeWidth: 28,
    strokeDasharray: "0 1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#3D7EDD",
}

export const SynetudesSVG = (props: { className?: string, repeat?: boolean }) => {
    const icon = {
        hidden: {
            opacity: 0,
            pathLength: 0,
        },
        visible: {
            opacity: 1,
            pathLength: 1,
        }
    };

    // custom={{ x: 50, delay: 15 }} {...pathProps}
    return (
        <div className={props.className}>

            <motion.svg width="100%" height="100%" className="absolute top-0 left-0" viewBox="0 0 1920 1080" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" >
                <g id="S" transform="matrix(1.1303,0,0,1.1303,-90.1377,-86.1016)">
                    <motion.path d="M312.761,370.281c-28.762,-26.897 -91.906,-42.777 -131.478,-8.956c-52.112,44.538 -7.588,97.951 38.55,121.358c42.584,21.604 67.895,64.278 37.345,102.035c-44.528,55.036 -118.982,36.701 -157.53,4.962" custom={{ delay: 0, duration: 0.5 }} {...pathProps} />
            </g>
                <g id="ynetu" transform="matrix(1.1303,0,0,1.1303,-120.416,-86.1016)">
                    <motion.path d="M293.836,568.447c15.638,-78.369 55.269,-108.601 73.36,-100.374c42.944,19.529 -55.536,129.446 -0.39,152.053c49.23,20.183 107.055,-64.987 134.819,-153.269c-15.797,50.898 -45.029,148.126 -58.118,184.688c-26.322,73.529 -48.114,98.742 -73.713,98.833c-21.984,0.077 -35.525,-20.093 -30.517,-40.164c3.65,-14.623 11.366,-31.372 52.531,-48.178c-0,0 70.913,-25.233 97.717,-40.644c61.06,-35.105 88.734,-58.842 100.793,-89.18c20.274,-51.01 94.241,-83.708 117.514,-55.2c25.333,31.032 -50.836,123.271 -11.872,141.637c31.291,14.75 154.39,-62.412 182.173,-91.463c58.723,-61.398 -42.304,-97.723 -81.659,0.33c-24.826,61.855 20.892,93.855 50.308,94.452c99.838,2.027 133.143,-104.952 173.203,-226.505c-39.047,118.128 -90.078,225.49 -23.023,226.972c75.404,1.666 120.764,-118.77 130.727,-154.257c-15.567,53.81 -67.476,144.063 -12.077,152.239c69.454,10.251 111.646,-105.875 126.377,-153.181c-28.987,92.354 -53.855,147.611 -24.273,154.82c29.112,7.095 72.031,-28.53 84.26,-58.039" custom={{ delay: 0.1, duration: 1.5 }} {...pathProps} />
            </g>
                <g id="n" transform="matrix(1.1303,0,0,1.1303,-120.416,-86.1016)">
                    <motion.path d="M611.283,466.965c-11.411,34.472 -33.963,106.423 -51.956,152.738" custom={{ delay: 0.4, duration: 0.1 }} {...pathProps} />
            </g>
                <g id="é" transform="matrix(1.1303,0,0,1.1303,-120.416,-86.1016)">
                    <motion.path d="M876.031,406.864c13.12,-17.304 21.715,-25.478 35.165,-43.28" custom={{ delay: 0.6, duration: 0.1 }} {...pathProps} />
            </g>
                <g transform="matrix(1.1303,0,0,1.1303,-120.416,-86.1016)">
                    <motion.path d="M954.593,474.379l94.842,-0" custom={{ delay: 0.7, duration: 0.1 }} {...pathProps} />
            </g>
                <g id="de" transform="matrix(1.1303,0,0,1.1303,-120.416,-86.1016)">
                    <motion.path d="M1493.45,340.552c-7.94,26.45 -23.614,74.923 -51.175,159.079c-22.912,69.96 -77.176,123.688 -111.033,120.322c-62.908,-6.254 -19.579,-125.214 29.179,-145.744c43.444,-18.292 87.716,6.041 83.224,19.958c-6.801,21.067 -39.913,97.066 -26.106,117.999c24.964,37.85 168.375,-54.64 199.824,-92.147c38.816,-46.293 -34.303,-89.721 -80.852,-7.51c-26.91,47.525 -11.429,103.024 35.13,108.506c78.38,9.228 142.263,-99.076 157.555,-121.839c36.19,-53.874 20.056,-65.533 8.334,-46.598c-11.722,18.935 2.67,47.815 23.409,74.865c20.738,27.05 27.005,66.086 3.781,84.992c-17.801,14.493 -50.668,13.508 -73.114,-2.188" custom={{ delay: 1, duration: 0.8 }} {...pathProps} />
            </g>
            </motion.svg>
        </div>
    )
}